import gql from 'graphql-tag';

export default gql`
    fragment Parent1 on Funeral {
        Parent1 {
            ID
            LastEdited
            Created
            Type
            Gender
            FirstName
            MiddleName
            Surname
            SurnameAtBirth
            Occupation
        }
    }
`;

export const Prearrangement = gql`
    fragment PrearrangementParent1 on Prearrangement {
        Parent1 {
            ID
            LastEdited
            Created
            Type
            Gender
            FirstName
            MiddleName
            Surname
            SurnameAtBirth
            Occupation
        }
    }
`;
